import { makeStyles } from "@mui/styles";
import React, { useState, Fragment, useEffect } from "react";
import { Colors } from "../../../helpers/Colors";
import { fontSize } from "../../../helpers/fontSize";
import { BiChevronLeft, BiChevronRight, BiArrowBack } from "react-icons/bi";
import { BsCheck, BsCheckAll } from "react-icons/bs";
import { TbDotsVertical } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import { Menu, Transition } from "@headlessui/react";
import { IoClose } from "react-icons/io5";
import {
  add,
  addDays,
  addMinutes,
  eachDayOfInterval,
  endOfMonth,
  format,
  getDay,
  isEqual,
  isPast,
  isSameDay,
  isSameMonth,
  isToday,
  parse,
  parseISO,
  startOfToday,
  sub,
} from "date-fns";
import toast, { Toaster } from "react-hot-toast";
import { KeyboardTimePicker } from "@material-ui/pickers";
// import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { Durations } from "../../../helpers/Durations";
import { useDispatch } from "react-redux";
import {
  remove_reservation_details,
  reservation_cabinName,
  reservation_details,
} from "../../../redux/Features/Reservation/ReservationSlice";
import axios from "axios";
import Confirm_Modal from "./section/Confirm_Modal";
import { Modal_useStyles } from "../../../useStyles/Modal_useStyles";
import { useNavigate } from "react-router-dom";
import {
  ax_addBooking,
  ax_allReservations,
  ax_getSlotsForDateRange_with_startDay,
} from "../../../api/reservation";
import { data } from "autoprefixer";

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      root: {
        backgroundColor: Colors.primary,
      },
    },
  },
});

const useStyles = makeStyles({
  Date: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    padding: "5px 0 5px 10px",
    height: "fit-content",
    // height: "400px",
    // width: "850px",
    // backgroundColor: Colors.primary,
    fontSize: fontSize.question,
    // // --------- from xs(380px) till md(770px)
    // "@media only screen and (max-Width: 770px)": {
    //   padding: "5px 10px",
    //   backgroundColor: Colors.error,
    // },
    // // --------- from md(770px) till xl(1200px)
    // "@media (min-width: 770px) and (max-width: 1200px)": {
    //   padding: "10px 40px",
    //   backgroundColor: Colors.secondary,
    // },
    // // --------- from xl(1200px) to above screen
    // "@media only screen and (min-width: 1200px)": {
    //   padding: "10px 120px",
    //   backgroundColor: Colors.logo8,
    // },
    // --------ipad
    "@media (min-width: 770px) and (max-width: 1200px)": {
      padding: "5px 0px 10px 40px",
      width: "650px",
    },
    // --------desktop
    "@media (min-width: 1200px) and (max-Width: 2560px) ": {
      padding: "5px 0px 10px 120px",
      width: "850px",
    },
    "@media only screen and (max-Width: 770px) ": {
      padding: "5px 10px",
      // width: "600px",
    },
    "& .Header": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      fontWeight: 600,
      boxShadow: `0px 3px 10px ${Colors.primaryMedium}`,
      "& .number": {
        width: "auto",
        height: "auto",
        padding: "8px 15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.primary,
        // --------- from xs(380px) till md(770px)
        "@media only screen and (max-Width: 770px)": {
          padding: "6.5px 14px",
        },
      },
      "& .question_chevron": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: Colors.white,
        padding: "0px 15px",
        // --------- from xs(380px) till md(770px)
        "@media only screen and (max-Width: 770px)": {
          padding: "0px 5px",
        },
        "& .question": {
          padding: "8px",
          // --------- from xs(380px) till md(770px)
          "@media only screen and (max-Width: 770px)": {
            padding: "8px 5px",
            fontSize: fontSize.modalInput,
          },
        },
        "& .rightCon": {
          display: "flex",
          padding: "8px 0px 8px 8px",
          "& .selected": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 500,
            fontSize: fontSize.selected,
            color: Colors.grey,
            "& span": {
              margin: "0px 5px",
              // --------- from xs(380px) till md(770px)
              "@media only screen and (max-Width: 770px)": {
                // padding: "8px 5px",
                fontSize: fontSize.label,
                // display: "none",
              },
            },
            "& .startTime, .endTime": {
              // --------- from xs(380px) till md(770px)
              "@media only screen and (max-Width: 500px)": {
                display: "none",
              },
            },
          },
          "& .iconCon": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // cursor: "pointer",
            "& .icon": {
              width: "25px",
              height: "25px",
            },
          },
        },
      },
    },
    "& .Body": {
      "& .BodyCon": {
        // display: "grid",
        // gridTemplateColumns: "422px 422px",
        // gridGap: "20px",
        // display: "flex",
        // alignContent: "center",
        // justifyContent: "flex-start",
        // flexWrap: "wrap",
        padding: "10px 0 0 0",
      },
    },
  },
  ReservedSlots: {
    padding: "5px 10px 5px 0",
    flexGrow: 1,
    fontSize: fontSize.question,
    // --------- from xs(380px) till md(770px)
    "@media only screen and (max-Width: 770px)": {
      padding: "5px 10px 5px 10px",
      fontSize: fontSize.modalInput,
    },
    // --------ipad
    "@media (min-width: 770px) and (max-width: 1200px)": {
      padding: "5px 40px 5px 0",
    },
    // --------desktop
    "@media (min-width: 1200px) and (max-Width: 2560px) ": {
      padding: "5px 120px 5px 0",
    },

    // "@media (min-Width: 1279px) and (max-Width: 1280px) ": {
    //   backgroundColor: Colors.error,
    // },
    "& .Header": {
      borderLeft: `1px solid ${Colors.secondary}`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontWeight: 600,
      width: "100%",
      backgroundColor: Colors.white,
      padding: "8px 0px 8px 0px",
      boxShadow: `5px 3px 10px ${Colors.primaryMedium}`,
      // --------- from xs(380px) till md(770px)
      "@media only screen and (max-Width: 770px)": {
        borderLeft: `0px solid ${Colors.secondary}`,
      },
      "& .question": {
        // padding: "8px",
        //   backgroundColor: "blue",
      },
    },
    "& .scrollbar": {
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "20px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: Colors.greyScrollBar,
        opacity: 0.2,
        borderRadius: "100vh",
        padding: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        width: "8px",
        backgroundColor: Colors.primary,
        borderRadius: "100vh",
        "&:hover": {
          backgroundColor: Colors.greyDark,
        },
      },
    },
  },
  Confirm: {
    "@media only screen and (max-Width: 770px) ": {
      padding: "0px 10px",
    },
    // // --------ipad
    "@media (min-width: 768px) and (max-width: 1023px)": {
      padding: "0px 40px",
    },
    // --------desktop
    "@media (min-width: 1024px) and (max-Width: 2560px) ": {
      padding: "0px 120px",
    },
  },
  CheckIconCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // cursor: "pointer",
    border: `2px solid ${Colors.success}`,
    borderRadius: "20px",
    color: Colors.success,
    margin: "0 5px 0 0",
    "& .icon": {
      width: "20px",
      height: "20px",
    },
  },
  EmptyCheckIconCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `2px solid ${Colors.grey}`,
    borderRadius: "20px",
    color: Colors.grey,
    margin: "0 5px 0 0",
    "& .emptyIcon": {
      // display: "none",
      visibility: "hidden",
      width: "20px",
      height: "20px",
    },
  },
  // className="bg-primary p-1 text-sm rounded-md shadow-md shadow-primaryMedium"
  Label_1_Active: {
    backgroundColor: Colors.primary,
    padding: "2px 5px",
    fontSize: fontSize.label,
    border: `1px solid ${Colors.primary}`,
    boxShadow: `1px 1px 1px 1px ${Colors.primaryMedium}`,
    borderRadius: "4px",
    cursor: "pointer",
  },
  Label_1: {
    padding: "2px 5px",
    fontSize: fontSize.label,
    border: `1px solid ${Colors.primary}`,
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: Colors.primary,
      boxShadow: `1px 1px 1px 1px ${Colors.primaryMedium}`,
    },
  },
});

const meetings = [
  {
    id: 1,
    name: "Leslie Alexander",
    imageUrl:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    startDatetime: "2022-07-11T13:00",
    endDatetime: "2022-07-11T14:30",
  },
  {
    id: 2,
    name: "Michael Foster",
    imageUrl:
      "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    startDatetime: "2022-07-20T09:00",
    endDatetime: "2022-07-20T11:30",
  },
  {
    id: 3,
    name: "Dries Vincent",
    imageUrl:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    startDatetime: "2022-07-20T17:00",
    endDatetime: "2022-07-20T18:30",
  },
  {
    id: 4,
    name: "Afrith Shariff",
    imageUrl:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    startDatetime: "2022-07-09T13:00",
    endDatetime: "2022-07-09T14:30",
  },
  {
    id: 5,
    name: "Michael Foster",
    imageUrl:
      "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    startDatetime: "2022-07-13T14:00",
    endDatetime: "2022-07-13T14:30",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

let colStartClasses = [
  "",
  "col-start-2",
  "col-start-3",
  "col-start-4",
  "col-start-5",
  "col-start-6",
  "col-start-7",
];

function Meeting({ meeting }) {
  let startDateTime = parseISO(meeting.startDatetime);
  let endDateTime = parseISO(meeting.endDatetime);

  return (
    <li className="flex items-center px-4 py-2 space-x-4 group rounded-xl focus-within:bg-gray-100 hover:bg-gray-100">
      {/* <img
        src={meeting.imageUrl}
        alt=""
        className="flex-none w-10 h-10 rounded-full"
      /> */}
      <div className="flex-auto">
        <p className="text-grey">{meeting.name}</p>
        <p className="mt-0.5 text-secondary">
          <time dateTime={meeting.startDatetime}>
            {format(startDateTime, "h:mm a")}
          </time>{" "}
          -{" "}
          <time dateTime={meeting.endDatetime}>
            {format(endDateTime, "h:mm a")}
          </time>
        </p>
      </div>
    </li>
  );
}

const DateComponent = ({
  user,
  sliderRef,
  cabinId,
  cabinName,
  today,
  selectedDay,
  setSelectedDay,
  startTime,
  setStartTime,
  add15mins,
  add30mins,
  add1hr,
  endTime,
  setEndTime,
  addTimetoStart,
  setAddTimetoStart,
  startTimePlus15mins,
  setStartTimePlus15mins,
  slideToPrevious,
  startTimePlus30mins,
  setStartTimePlus30mins,
  startTimePlus1hr,
  setStartTimePlus1hr,
  // slideNextToDetails,
  selectCabinPlease,
  selectDatePlease,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  const Modal_Classes = Modal_useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [reservedSlots, setReservedSlots] = useState([]);
  const [dayHasOneSlot, setDayHasOneSlot] = useState([]);

  // const [showDateContent, setShowDateContent] = useState(false);

  // const [addTimetoStart, setAddTimetoStart] = useState("");
  // // For Automatically adding __mins/ _hr to the startTime
  const [startTimeForEndTime, setStartTimeForEndTime] = useState(new Date());
  const [startTimeChanges, setStartTimeChanges] = useState(false);
  // // For Automatically adding 15mins to the startTime
  const [onClicked15mins, setOnClick15mins] = useState(false);
  // const [startTimePlus15mins, setStartTimePlus15mins] = useState(new Date());
  // For Automatically adding 30mins to the startTime
  const [onClicked30mins, setOnClick30mins] = useState(false);
  // const [startTimePlus30mins, setStartTimePlus30mins] = useState(new Date());
  // For Automatically adding 1hr to the startTime
  const [onClicked1hr, setOnClick1hr] = useState(false);
  // const [startTimePlus1hr, setStartTimePlus1hr] = useState(new Date());

  const addTimetoStartChangeHandler = (e) => {
    setAddTimetoStart(e.target.value);
  };

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [rotateDateChevron, setRotateDateChevron] = useState(false);
  const rotateDateChev = rotateDateChevron ? "rotate(180deg)" : "rotate(0deg)";
  const onDateHeaderClick = () => {
    // setShowDateContent(!showDateContent);
    setRotateDateChevron(!rotateDateChevron);
  };
  const onBookCabinClick = async () => {
    setShowConfirmModal(!showConfirmModal);
    await dispatch(
      reservation_cabinName({
        cabinName,
        cabinId,
      })
    );
    // dispatch(remove_reservation_details(null));
    await dispatch(
      reservation_details({
        selectedDay,
        startTime,
        endTime,
        addTimetoStart,
        startTimePlus15mins,
        startTimePlus30mins,
        startTimePlus1hr,
      })
    );
    toast.success(
      "Now, Confirm your Booking!"
      // , {
      //   icon: "😊",
      // }
    );
  };
  const onCloseClick = () => {
    setShowConfirmModal(!showConfirmModal);
    dispatch(remove_reservation_details());
    setUseEffect(true);
  };
  const ConfirmReservationHandler = async (e) => {
    e.preventDefault();
    // sliderRef.current.slickNext();
    const data = {
      cabinId,
      cabinName,
      selectedDay,
      startTime,
      addTimetoStart,
      startTimePlus15mins,
      startTimePlus30mins,
      startTimePlus1hr,
      endTime,
      user,
    };

    try {
      const ax = await ax_addBooking(data);
      if (ax.code === 200) {
        toast.success(ax.description);
        navigate("/myReservations");
      } else {
        toast.error(ax.description);
      }
    } catch (e) {
      console.log(`err:- ` + e);
    }
  };

  const values = {
    selectedDay: selectedDay,
    startTime: format(startTime, "hh:mm a"),
    endTime: format(endTime, "hh:mm a"),
    addTimetoStart: addTimetoStart,
    startTimePlus15mins: format(startTimePlus15mins, "hh:mm a"),
    startTimePlus30mins: startTimePlus30mins,
    startTimePlus1hr: startTimePlus1hr,
  };

  console.log("values ---> " + JSON.stringify(values));

  // useEffect(() => {
  //   if (!showConfirmModal) {
  //     console.log("afrid - this is not");
  //     console.log(showConfirmModal);
  //   } else {
  //     console.log("Shanawas");
  //     console.log(showConfirmModal);
  //   }
  // }, [showConfirmModal]);

  // ********** date-fns ***********
  // let today = startOfToday();
  // let [selectedDay, setSelectedDay] = useState(today);
  const [selecetdDate, setSelectedDate] = useState("");
  // const [selecetdDate, setSelectedDate] = useState(null);
  let [currentMonth, setCurrentMonth] = useState(format(today, "MMM-yyyy"));
  let firstDayCurrentMonth = parse(currentMonth, "MMM-yyyy", new Date());

  let days = eachDayOfInterval({
    start: firstDayCurrentMonth,
    end: endOfMonth(firstDayCurrentMonth),
  });

  function previousMonth() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: -1 });
    setCurrentMonth(format(firstDayNextMonth, "MMM-yyyy"));
  }

  function nextMonth() {
    let firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 });
    setCurrentMonth(format(firstDayNextMonth, "MMM-yyyy"));
  }

  let selectedDayMeetings = meetings.filter((meeting) =>
    isSameDay(parseISO(meeting.startDatetime), selectedDay)
  );

  const onDateClick = (day) => {
    setSelectedDay(day);
    // {JSON.stringify(day)}
    // setSelectedDate(day);
  };

  const slideNextToDetails = () => {
    sliderRef.current.slickNext();
  };

  /* Function to add 15 mins to startTime */
  const addOffTo = () => {
    add15mins = addMinutes(startTime, 0);
    // setOnClick15mins(true);
    // setStartTimePlus15mins(add15mins);
    // setStartTimeForEndTime(startTimePlus15mins);
  };
  const add15minsTo = () => {
    add15mins = addMinutes(startTime, 15);
    setOnClick15mins(true);
    setStartTimePlus15mins(add15mins);
    setStartTimeForEndTime(startTimePlus15mins);
  };
  const add30minsTo = () => {
    add30mins = addMinutes(startTime, 30);
    setOnClick30mins(true);
    setStartTimePlus30mins(add30mins);
    setStartTimeForEndTime(startTimePlus30mins);
  };
  const add1hrTo = () => {
    add1hr = addMinutes(startTime, 60);
    setOnClick1hr(true);
    setStartTimePlus1hr(add1hr);
    setStartTimeForEndTime(startTimePlus1hr);
  };

  /* **********************************************
   This useEffect make sure the startTime to add 15mins automatically when the startTimeChanges && onClicked15mins becomes - true
  ********************************************** */
  useEffect(() => {
    if (startTimeChanges === true) {
      if (onClicked15mins === true) {
        add15minsTo();
      }
    }
  }, [startTime, startTimeChanges, onClicked15mins, addTimetoStart]);
  /* **********************************************
   This useEffect make sure the startTime to add 30mins automatically when the startTimeChanges && onClicked15mins becomes - true
  ********************************************** */
  useEffect(() => {
    if (startTimeChanges === true && onClicked30mins === true) {
      add30minsTo();
    }
  }, [startTime, startTimeChanges, onClicked30mins]);
  /* **********************************************
   This useEffect make sure the startTime to add 1hr automatically when the startTimeChanges && onClicked15mins becomes - true
  ********************************************** */
  useEffect(() => {
    if (startTimeChanges === true && onClicked1hr === true) {
      add1hrTo();
    }
  }, [startTime, startTimeChanges, onClicked1hr]);
  // console.log(
  //   "SELECTED DATE:",
  //   format("2022-08-17T09:36:50.221Z", "dd-MM-yyyy")
  // );
  useEffect(() => {
    const startDay = format(
      sub(selectedDay, { days: 1 }),
      "yyyy-MM-ddTHH:mm:ss.SSS"
    );
    const endDay = format(selectedDay, "yyyy-MM-ddTHH:mm:ss.SSS");
    const ax_fetch = async () => {
      try {
        const ax = await ax_getSlotsForDateRange_with_startDay(
          startDay,
          endDay
        );
        if (ax.code === 200 || ax.code === 201) {
          // console.log("res:", res.data);
          setReservedSlots(ax.data);
        }
      } catch (e) {
        console.log("e: --> ", e);
      }
    };
    ax_fetch();
    // axios
    //   .get(
    //     `/api/get/getSlotsForDateRange?startDay=${startDay}&endDay=${endDay}`
    //     // `/api/get/getSlotsForDateRange?cabinName=${cabinName}`
    //   )
    //   .then((res) => {
    //     // console.log("res:", res.data);
    //     setReservedSlots(res.data);
    //   })
    //   .catch((err) => {
    //     console.log("err:", err);
    //   });
  }, [selectedDay]);

  useEffect(() => {
    const ax_fetch = async () => {
      try {
        const ax = await ax_allReservations();
        console.log("ax --> :", ax);
        if (ax.code === 200) {
          setDayHasOneSlot(ax.data);
          setUseEffect(true);
        }
      } catch (e) {
        console.log("e: --> ", e);
      }
    };
    ax_fetch();
    // axios
    //   .get(
    //     `/api/get/allReservations`
    //     // `/api/get/getSlotsForDateRange?cabinName=${cabinName}`
    //   )
    //   .then((res) => {
    //     setDayHasOneSlot(res.data);
    //     setUseEffect(true);
    //   })
    //   .catch((err) => {
    //     console.log("err:", err);
    //   });
  }, [triggerUseEffect, selectedDay]);

  return (
    <ThemeProvider theme={materialTheme} className="flex">
      <main className="flex flex-col md:flex-row">
        {/* Reserved Slots */}
        {/* <section className={`${classes.ReservedSlots} md:hidden`}>
          <main className="Header">Reserved Slots</main>
          <main
            className={`scrollbar py-[10px] h-[22rem] overflow-y-scroll 
            ${
              reservedSlots.length > 10 ? `scrollbar-default` : `scrollbar-hide`
            }
            `}
          >
            {reservedSlots.length > 0 ? (
              reservedSlots.map((slots) => {
                // {
                //   JSON.stringify(startTime);
                // }
                // {
                //   JSON.stringify(startTime);
                // }
                // console.log(slots);
                return (
                  <div className="flex items-center justify-center text-selected font-medium py-1">
                    <section
                      style={{
                        color:
                          // startTime equals to slots.startTime
                          format(startTime, "hh:mm a") >=
                          format(new Date(slots.startTime), "hh:mm a")
                            ? Colors.error
                            : Colors.primary ||
                              format(startTime, "hh:mm a") <=
                                format(new Date(slots.startTime), "hh:mm a")
                            ? Colors.error
                            : Colors.primary,
                        // || format(),
                        // || // startTime greater than slots.startTime and startTimePlus15mins || startTimePlus30mins || startTimePlus1hr || endTime less than slots.startTime
                        //   (format(startTime, "hh:mm a") >
                        //     format(new Date(slots.startTime), "hh:mm a") &&
                        //     //   format(startTimePlus15mins, "hh:mm a")) ||
                        //     // format(startTimePlus30mins, "hh:mm a") ||
                        //     // format(startTimePlus1hr, "hh:mm a") ||
                        //     // format(endTime, "hh:mm a")
                        //     format(startTime, "hh:mm a") <
                        //       format(new Date(slots.endTime), "hh:mm a"))
                        // ? Colors.error
                        // : Colors.primary ||
                        //   format(startTime, "hh:mm a") >
                        //     format(new Date(slots.startTime), "hh:mm a")
                        // ? Colors.error
                        // : Colors.primary ||
                        //   //   format(startTimePlus15mins, "hh:mm a")) ||
                        //   // format(startTimePlus30mins, "hh:mm a") ||
                        //   // format(startTimePlus1hr, "hh:mm a") ||
                        //   // format(endTime, "hh:mm a")
                        //   format(startTime, "hh:mm a") <
                        //     format(new Date(slots.endTime), "hh:mm a")
                        // ? Colors.error
                        // : // startTime greater than slots.endTime and startTimePlus15mins || startTimePlus30mins || startTimePlus1hr || endTime less than slots.endTime
                        //   // (format(startTime, "hh:mm a") <
                        //   //     format(new Date(slots.endTime), "hh:mm a") &&
                        //   //     format(startTimePlus15mins, "hh:mm a")) ||
                        //   //   format(startTimePlus30mins, "hh:mm a") ||
                        //   //   format(startTimePlus1hr, "hh:mm a") ||
                        //   //   format(endTime, "hh:mm a") <
                        //   //     format(new Date(slots.endTime), "hh:mm a")
                        //   //
                        //   // // slots.startTime and slots.endTime less than endTime
                        //   // format(new Date(slots.startTime), "hh:mm a") &&
                        //   // format(new Date(slots.endTime), "hh:mm a") <
                        //   //   format(new Date(endTime), "hh:mm a")
                        //   // Colors.jerry
                        //   Colors.primary,
                      }}
                    >
                      {format(new Date(slots.startTime), "hh:mm a")} -
                    </section>
                    <section
                      style={{
                        color:
                          // format(new Date(endTime), "hh:mm a") ===
                          //   format(new Date(slots.endTime), "hh:mm a") ||
                          // (format(new Date(endTime), "hh:mm a") >
                          //   format(new Date(slots.startTime), "hh:mm a") &&
                          //   format(new Date(endTime), "hh:mm a") <
                          //     format(new Date(slots.endTime), "hh:mm a"))

                          // format(new Date(startTime), "hh:mm a") ===
                          //   format(new Date(slots.startTime), "hh:mm a") ||
                          // (format(new Date(startTime), "hh:mm a") >
                          //   format(new Date(slots.startTime), "hh:mm a") &&
                          //   format(new Date(startTime), "hh:mm a") <
                          //     format(new Date(slots.endTime), "hh:mm a")) ||
                          // (format(new Date(slots.startTime), "hh:mm a") &&
                          //   format(new Date(slots.endTime), "hh:mm a") >
                          //     format(new Date(startTime), "hh:mm a") &&
                          //   format(new Date(endTime), "hh:mm a"))
                          //   ? Colors.error
                          //   : Colors.primary,
                          // endTime equals to slots.endTime
                          format(startTimePlus15mins, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a") ||
                          format(startTimePlus30mins, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a") ||
                          format(startTimePlus1hr, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a") ||
                          format(endTime, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a")
                            ? Colors.error
                            : format(startTimePlus15mins, "hh:mm a") >
                                format(new Date(slots.startTime), "hh:mm a") ||
                              format(startTimePlus30mins, "hh:mm a") >
                                format(new Date(slots.startTime), "hh:mm a") ||
                              format(startTimePlus1hr, "hh:mm a") >
                                format(new Date(slots.startTime), "hh:mm a") ||
                              format(endTime, "hh:mm a") <
                                format(new Date(slots.endTime), "hh:mm a")
                            ? Colors.error
                            : Colors.primary,
                      }}
                    >
                      {" "}
                      {format(new Date(slots.endTime), "hh:mm a")}
                    </section>
                  </div>
                );
              })
            ) : (
              <div className="flex items-center justify-center text-selected font-medium py-1">
                All Slots are Available
              </div>
            )}
          </main>
        </section> */}
        <section className={classes.Date}>
          <main className="Header" onClick={onDateHeaderClick}>
            <section className="number">2</section>
            <section className="question_chevron">
              <div className="question">Choose Date & Time</div>
              <div className="rightCon">
                <div className="selected">
                  <span
                    className="day"
                    dateTime={format(selectedDay, "yyyy-MM-dd")}
                  >
                    {isEqual(today, selectedDay)
                      ? "Today"
                      : format(selectedDay, "MMM dd, yyy")}
                  </span>
                  <span className="startTime">
                    {" "}
                    -{" "}
                    {startTime
                      ? startTime.toLocaleTimeString(navigator.language, {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "startTime"}
                  </span>

                  <span className="endTime">
                    {" "}
                    -{" "}
                    {addTimetoStart === Durations.minutes15
                      ? format(startTimePlus15mins, "hh:mm a")
                      : addTimetoStart === Durations.minutes30
                      ? format(startTimePlus30mins, "hh:mm a")
                      : addTimetoStart === Durations.hour1
                      ? format(startTimePlus1hr, "hh:mm a")
                      : format(endTime, "hh:mm a")}
                  </span>
                </div>
                {selectedDay ? (
                  <div className={classes.CheckIconCon}>
                    <BsCheck className="icon" />
                  </div>
                ) : (
                  <div className={classes.EmptyCheckIconCon}>
                    <BsCheck className="emptyIcon" />
                  </div>
                )}

                {/* <div className="iconCon">
              <HiChevronDown
                className="icon"
                style={{
                  transform: rotateDateChev,
                  transition: "0.3s linear",
                }}
              />
            </div> */}
              </div>
            </section>
          </main>
          <main className="Body">
            <section className="BodyCon">
              <div className="pt-0 w-full">
                {/* <div className="max-w-md px-4 h-[360px] mx-auto sm:px-7 md:max-w-2xl md:px-6"> */}
                <div className="">
                  <div className="flex flex-col 500px:flex-row md:grid md:grid-cols-2 md:divide-x md:divide-gray-200">
                    {/* Calendar */}
                    <div className="px-3 md:px-5 flex-grow md:flex-grow-0 md:pr-4">
                      <div className="flex items-center">
                        <h2 className="flex-auto font-semibold text-gray-900">
                          {format(firstDayCurrentMonth, "MMMM yyyy")}
                        </h2>
                        <button
                          type="button"
                          onClick={previousMonth}
                          className="-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">Previous month</span>
                          <BiChevronLeft
                            className="w-5 h-5"
                            aria-hidden="true"
                          />
                        </button>
                        <button
                          onClick={nextMonth}
                          type="button"
                          className="-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">Next month</span>
                          <BiChevronRight
                            className="w-5 h-5"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      <div className="grid grid-cols-7 mt-2 text-xs leading-6 text-center text-jerry">
                        <div>S</div>
                        <div>M</div>
                        <div>T</div>
                        <div>W</div>
                        <div>T</div>
                        <div>F</div>
                        <div>S</div>
                      </div>
                      <div className="grid grid-cols-7 mt-2 text-sm">
                        {days.map((day, dayIdx) => (
                          <div
                            key={day.toString()}
                            className={classNames(
                              dayIdx === 0 && colStartClasses[getDay(day)],
                              "pt-1.5 pb-1"
                            )}
                          >
                            <button
                              type="button"
                              onClick={() => {
                                onDateClick(day);
                              }}
                              disabled={
                                isPast(day) > isToday(day) ? true : false
                              }
                              className={classNames(
                                isPast(day) > isToday(day) && "text-gray-400",
                                isEqual(day, selectedDay) && "text-white",
                                !isEqual(day, selectedDay) &&
                                  isToday(day) &&
                                  "bg-primary text-secondary",
                                !isEqual(day, selectedDay) &&
                                  !isToday(day) &&
                                  isSameMonth(day, firstDayCurrentMonth) &&
                                  "text-gray-900",
                                !isEqual(day, selectedDay) &&
                                  !isToday(day) &&
                                  !isSameMonth(day, firstDayCurrentMonth) &&
                                  "text-gray-400",
                                isEqual(day, selectedDay) &&
                                  isToday(day) &&
                                  "bg-primary text-secondary",
                                isEqual(day, selectedDay) &&
                                  !isToday(day) &&
                                  "bg-secondary",
                                !isEqual(day, selectedDay) &&
                                  isPast(day) <= isToday(day) &&
                                  "hover:bg-primaryMedium",
                                (isEqual(day, selectedDay) || isToday(day)) &&
                                  "font-semibold",
                                "mx-auto flex h-8 w-8 items-center justify-center rounded-full"
                              )}
                            >
                              <time dateTime={format(day, "yyyy-MM-dd")}>
                                {format(day, "d")}
                              </time>
                            </button>

                            <div className="w-1 h-1 mx-auto mt-1">
                              {dayHasOneSlot.some(
                                (meeting) =>
                                  isSameDay(parseISO(meeting.day), day) &&
                                  isPast(day) <= isToday(day)
                              ) && (
                                <div className="w-1 h-1 rounded-full bg-jerry"></div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Keyboard Time Input */}
                    <section className="flex-row items-center justify-between mt-2 md:mt-0 md:pl-[0rem]">
                      {/* Start Time */}
                      <div className="mt-4 500px:mt-14 flex items-center justify-center">
                        <KeyboardTimePicker
                          label="Start Time"
                          placeholder="08:00 AM"
                          mask="__:__ _M"
                          orientation="landscape"
                          value={startTime}
                          onChange={(date) => {
                            setStartTime(date);
                          }}
                          onAccept={() => {
                            setStartTimeChanges(true);
                            if (addTimetoStart === Durations.minutes15) {
                              setOnClick15mins(true);
                            } else if (addTimetoStart === Durations.minutes30) {
                              setOnClick30mins(true);
                            } else if (addTimetoStart === Durations.hour1) {
                              setOnClick1hr(true);
                            } else {
                              // console.log("OnAccept_Working");
                            }
                            // addTimetoStart === Durations.minutes15
                            //   ? setOnClick15mins(true)
                            //   : addTimetoStart === Durations.minutes30
                            //   ? setOnClick30mins(true)
                            //   : addTimetoStart === Durations.hour1
                            //   ? setOnClick1hr(true)
                            //   : "";
                          }}
                        />
                      </div>
                      {/* {`startTime-${JSON.stringify(
                      format(startTime, "hh:mm a")
                    )}`}
                    <br />
                    {`endTime-${JSON.stringify(format(endTime, "hh:mm a"))}`} */}
                      <div className="my-8 space-x-2 flex items-center justify-center">
                        {/* Add{" "} */}
                        <label
                          htmlFor={Durations.off}
                          className={`${
                            addTimetoStart === Durations.off
                              ? classes.Label_1_Active
                              : classes.Label_1
                          }`}
                          // className="bg-primary p-1 text-sm rounded-md shadow-md shadow-primaryMedium"
                        >
                          <span onClick={addOffTo} className="">
                            {Durations.off}
                          </span>{" "}
                        </label>
                        <input
                          className="hidden"
                          type={"radio"}
                          id={Durations.off}
                          value={Durations.off}
                          checked={addTimetoStart === Durations.off}
                          // onChange={addTimetoStartChangeHandler}
                          onChange={(e) => {
                            setAddTimetoStart(e.target.value);
                            setOnClick15mins(true);
                          }}
                        />
                        <label
                          htmlFor={Durations.minutes15}
                          className={`${
                            addTimetoStart === Durations.minutes15
                              ? classes.Label_1_Active
                              : classes.Label_1
                          }`}
                        >
                          <span onClick={add15minsTo}>
                            {Durations.minutes15}
                          </span>{" "}
                        </label>
                        <input
                          className="hidden"
                          type={"radio"}
                          id={Durations.minutes15}
                          value={Durations.minutes15}
                          checked={addTimetoStart === Durations.minutes15}
                          // onChange={addTimetoStartChangeHandler}
                          onChange={(e) => {
                            setAddTimetoStart(e.target.value);
                            setOnClick30mins(true);
                          }}
                        />
                        <label
                          htmlFor={Durations.minutes30}
                          className={`${
                            addTimetoStart === Durations.minutes30
                              ? classes.Label_1_Active
                              : classes.Label_1
                          }`}
                        >
                          <span onClick={add30minsTo}>
                            {Durations.minutes30}
                          </span>{" "}
                        </label>
                        <input
                          className="hidden"
                          type={"radio"}
                          id={Durations.minutes30}
                          value={Durations.minutes30}
                          checked={addTimetoStart === Durations.minutes30}
                          // onChange={addTimetoStartChangeHandler}
                          onChange={(e) => {
                            setAddTimetoStart(e.target.value);
                            setOnClick30mins(true);
                          }}
                        />
                        <label
                          htmlFor={Durations.hour1}
                          className={`${
                            addTimetoStart === Durations.hour1
                              ? classes.Label_1_Active
                              : classes.Label_1
                          }`}
                        >
                          <span onClick={add1hrTo}>{Durations.hour1}</span>
                        </label>
                        <input
                          className="hidden"
                          type={"radio"}
                          id={Durations.hour1}
                          value={Durations.hour1}
                          checked={addTimetoStart === Durations.hour1}
                          // onChange={addTimetoStartChangeHandler}
                          onChange={(e) => {
                            setAddTimetoStart(e.target.value);
                            setOnClick1hr(true);
                          }}
                        />
                        {/* to the startTime */}
                      </div>
                      {/* End Time */}
                      <div className="mb-2 500px:mb-0 flex items-center justify-center">
                        <KeyboardTimePicker
                          label="End Time"
                          placeholder="08:00 AM"
                          mask="__:__ _M"
                          orientation="landscape"
                          value={
                            addTimetoStart === Durations.minutes15
                              ? startTimePlus15mins
                              : addTimetoStart === Durations.minutes30
                              ? startTimePlus30mins
                              : addTimetoStart === Durations.hour1
                              ? startTimePlus1hr
                              : endTime
                            // endTime
                            // startTimePlus15mins
                            // startTimePlus30mins
                            // startTimePlus1hr
                            // onClicked15mins === true
                            //   ? startTimePlus15mins
                            //   : onClicked30mins === true
                            //   ? startTimePlus30mins
                            //   : onClicked1hr === true
                            //   ? startTimePlus1hr
                            //   : endTime
                            // : endTime
                          }
                          onChange={(date) => {
                            setEndTime(date);
                            startTime < endTime
                              ? toast.error(
                                  "End Time should be more than Start Time"
                                )
                              : toast.success("Good");
                            // if (startTime < endTime) {
                            //   toast.error(
                            //     "End Time should be more than Start Time"
                            //   );
                            // } else {
                            //   toast.success("Good");
                            // }
                          }}
                          // minDate={format(startTime, "hh:mm a")}
                          // minDateMessage={"Hello"}
                          // onAccept={() => {
                          //   // const difference = start;
                          //   if (startTime < endTime) {
                          //     toast.error(
                          //       "End Time should be more than Start Time"
                          //     );
                          //   } else {
                          //     toast.success("Good");
                          //   }
                          // }}
                        />
                      </div>
                      {/* <h2 className="w-max font-semibold text-gray-900">
                    {selectedDayMeetings.length > 0 ? (
                      <span className="text-error">Slots not available</span>
                    ) : (
                      <span className="text-success">Slots available</span>
                    )}

                    <time dateTime={format(selectedDay, "yyyy-MM-dd")}>
                      {" "}
                      on {format(selectedDay, "MMM dd, yyy")}
                    </time>
                  </h2>
                  <ol className="mt-4 space-y-1 text-sm leading-6 text-gray-500">
                    {selectedDayMeetings.length > 0 ? (
                      selectedDayMeetings.map((meeting) => (
                        <Meeting meeting={meeting} key={meeting.id} />
                      ))
                    ) : (
                      <p dateTime={format(selectedDay, "yyyy-MM-dd")}>
                        No meetings for {format(selectedDay, "MMM dd, yyy")}.
                      </p>
                    )}
                  </ol> */}
                    </section>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </section>
        {/* Reserved Slots */}
        <section className={`${classes.ReservedSlots} `}>
          <main className="Header">Reserved Slots</main>
          <main
            className={`scrollbar py-[10px] h-[5rem] xl:h-[22rem] overflow-y-scroll 
            ${reservedSlots.length > 5 ? `scrollbar-default` : `scrollbar-hide`}
            `}
          >
            {reservedSlots.length > 0 ? (
              reservedSlots.map((slots) => {
                // {
                //   JSON.stringify(startTime);
                // }
                // {
                //   JSON.stringify(startTime);
                // }
                // console.log(slots);
                return (
                  <div className="flex items-center justify-center text-selected font-medium py-1">
                    <section
                      style={{
                        color:
                          // startTime equals to slots.startTime
                          format(startTime, "hh:mm a") >=
                          format(new Date(slots.startTime), "hh:mm a")
                            ? Colors.error
                            : Colors.primary ||
                              format(startTime, "hh:mm a") <=
                                format(new Date(slots.startTime), "hh:mm a")
                            ? Colors.error
                            : Colors.primary,
                        // || format(),
                        // || // startTime greater than slots.startTime and startTimePlus15mins || startTimePlus30mins || startTimePlus1hr || endTime less than slots.startTime
                        //   (format(startTime, "hh:mm a") >
                        //     format(new Date(slots.startTime), "hh:mm a") &&
                        //     //   format(startTimePlus15mins, "hh:mm a")) ||
                        //     // format(startTimePlus30mins, "hh:mm a") ||
                        //     // format(startTimePlus1hr, "hh:mm a") ||
                        //     // format(endTime, "hh:mm a")
                        //     format(startTime, "hh:mm a") <
                        //       format(new Date(slots.endTime), "hh:mm a"))
                        // ? Colors.error
                        // : Colors.primary ||
                        //   format(startTime, "hh:mm a") >
                        //     format(new Date(slots.startTime), "hh:mm a")
                        // ? Colors.error
                        // : Colors.primary ||
                        //   //   format(startTimePlus15mins, "hh:mm a")) ||
                        //   // format(startTimePlus30mins, "hh:mm a") ||
                        //   // format(startTimePlus1hr, "hh:mm a") ||
                        //   // format(endTime, "hh:mm a")
                        //   format(startTime, "hh:mm a") <
                        //     format(new Date(slots.endTime), "hh:mm a")
                        // ? Colors.error
                        // : // startTime greater than slots.endTime and startTimePlus15mins || startTimePlus30mins || startTimePlus1hr || endTime less than slots.endTime
                        //   // (format(startTime, "hh:mm a") <
                        //   //     format(new Date(slots.endTime), "hh:mm a") &&
                        //   //     format(startTimePlus15mins, "hh:mm a")) ||
                        //   //   format(startTimePlus30mins, "hh:mm a") ||
                        //   //   format(startTimePlus1hr, "hh:mm a") ||
                        //   //   format(endTime, "hh:mm a") <
                        //   //     format(new Date(slots.endTime), "hh:mm a")
                        //   //
                        //   // // slots.startTime and slots.endTime less than endTime
                        //   // format(new Date(slots.startTime), "hh:mm a") &&
                        //   // format(new Date(slots.endTime), "hh:mm a") <
                        //   //   format(new Date(endTime), "hh:mm a")
                        //   // Colors.jerry
                        //   Colors.primary,
                      }}
                    >
                      {format(new Date(slots.startTime), "hh:mm a")} -
                    </section>
                    <section
                      style={{
                        color:
                          // format(new Date(endTime), "hh:mm a") ===
                          //   format(new Date(slots.endTime), "hh:mm a") ||
                          // (format(new Date(endTime), "hh:mm a") >
                          //   format(new Date(slots.startTime), "hh:mm a") &&
                          //   format(new Date(endTime), "hh:mm a") <
                          //     format(new Date(slots.endTime), "hh:mm a"))

                          // format(new Date(startTime), "hh:mm a") ===
                          //   format(new Date(slots.startTime), "hh:mm a") ||
                          // (format(new Date(startTime), "hh:mm a") >
                          //   format(new Date(slots.startTime), "hh:mm a") &&
                          //   format(new Date(startTime), "hh:mm a") <
                          //     format(new Date(slots.endTime), "hh:mm a")) ||
                          // (format(new Date(slots.startTime), "hh:mm a") &&
                          //   format(new Date(slots.endTime), "hh:mm a") >
                          //     format(new Date(startTime), "hh:mm a") &&
                          //   format(new Date(endTime), "hh:mm a"))
                          //   ? Colors.error
                          //   : Colors.primary,
                          // endTime equals to slots.endTime
                          format(startTimePlus15mins, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a") ||
                          format(startTimePlus30mins, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a") ||
                          format(startTimePlus1hr, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a") ||
                          format(endTime, "hh:mm a") ===
                            format(new Date(slots.endTime), "hh:mm a")
                            ? Colors.error
                            : format(startTimePlus15mins, "hh:mm a") >
                                format(new Date(slots.startTime), "hh:mm a") ||
                              format(startTimePlus30mins, "hh:mm a") >
                                format(new Date(slots.startTime), "hh:mm a") ||
                              format(startTimePlus1hr, "hh:mm a") >
                                format(new Date(slots.startTime), "hh:mm a") ||
                              format(endTime, "hh:mm a") <
                                format(new Date(slots.endTime), "hh:mm a")
                            ? Colors.error
                            : Colors.primary,
                      }}
                    >
                      {" "}
                      {format(new Date(slots.endTime), "hh:mm a")}
                    </section>
                  </div>
                );
              })
            ) : (
              <div className="flex items-center justify-center text-selected font-medium py-1">
                All Slots are Available
              </div>
            )}
          </main>
        </section>
      </main>
      <div className={`${classes.Confirm}`}>
        {cabinName && selectedDay ? (
          <section
            className="flex items-center justify-end bg-primary w-fit m-2 p-2 rounded-md float-right cursor-pointer"
            onClick={onBookCabinClick}
          >
            <div className="flex items-center justify-center">
              <BsCheckAll className="w-6 h-6" />
            </div>
            <div className="text-base font-medium px-1">Book a Cabin</div>
          </section>
        ) : (
          <section
            className="flex items-center justify-end bg-grey w-fit m-2 p-2 rounded-md float-right"
            onClick={cabinName === "" && selectCabinPlease}
          >
            <div className="flex items-center justify-center">
              <BsCheckAll className="w-6 h-6" />
            </div>
            <div className="text-base font-medium px-1">Next</div>
          </section>
        )}
      </div>
      {showConfirmModal && (
        <main className={Modal_Classes.Modal_Background}>
          <main className={Modal_Classes.Update_Import_Modal}>
            <section className={"Import_Modal_Container"}>
              <div className="update">Confirm Reservation</div>
              <div className="closeIconCon_Relative" onClick={onCloseClick}>
                <IoClose className="closeIcon_Relative" />
              </div>
              <main>
                <Confirm_Modal
                  user={user}
                  ConfirmReservationHandler={ConfirmReservationHandler}
                />
              </main>
            </section>
          </main>
        </main>
      )}
    </ThemeProvider>
  );
};

export default DateComponent;
